import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

window.dataLayer = window.dataLayer || [];
function gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
}

gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
});

if (CookieConsent.getCookie('categories', 'cc_cookie')) {
    const acceptedCategories = CookieConsent.getCookie('categories', 'cc_cookie') || [];
    gtag('consent', 'update', {
        ad_storage: acceptedCategories.includes('analytics') ? 'granted' : 'denied',
        ad_user_data: acceptedCategories.includes('analytics') ? 'granted' : 'denied',
        ad_personalization: acceptedCategories.includes('analytics') ? 'granted' : 'denied',
        analytics_storage: acceptedCategories.includes('analytics') ? 'granted' : 'denied',
    });
}

function manageConsent() {
    gtag('consent', 'update', {
        ad_storage: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        ad_user_data: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        ad_personalization: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        analytics_storage: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
    });
    if (CookieConsent.acceptedCategory('analytics')) {
        gtag('event', 'accept_all', {
            event_category: 'Cookie Consent',
            event_label: 'L’utilisateur a accepté tous les cookies',
        });
    } else {
        gtag('event', 'reject_all', {
            event_category: 'Cookie Consent',
            event_label: 'L’utilisateur a refusé tous les cookies',
        });
    }
}

window.addEventListener('load', () => {
    CookieConsent.run({
        onFirstConsent() {
            manageConsent();
            window.dataLayer.push({ event: 'consent_ready' });
        },
        onChange() {
            manageConsent();
            window.dataLayer.push({ event: 'consent_update' });
        },
        categories: {
            necessary: {
                enabled: true,
                readOnly: true,
            },
            analytics: {
                autoClear: {
                    cookies: [
                        {
                            name: /^(_)/,
                            domain: 'rtcquebec.ca',
                        },
                        {
                            name: /^(cebs)/,
                            domain: 'rtcquebec.ca',
                        },
                    ],
                },
            },
        },
        guiOptions: {
            consentModal: {
                layout: 'bar',
                position: 'bottom right',
            },
        },
        language: {
            default: 'fr',
            autoDetect: 'document',
            translations: {
                fr: {
                    consentModal: {
                        title: 'Consentement aux témoins de navigation (cookies)',
                        description:
                            'Nous tenons à vous informer que notre site web utilise des témoins de navigation pour assurer le bon fonctionnement du site web, l’accès aux statistiques de consultation et la communication de messages ciblés à nos usagers sur d’autres plateformes Web. En cliquant sur « Tout accepter », vous consentez à notre utilisation des témoins de navigation.<br><a href="/politique-sur-la-confidentialite-et-la-protection-des-renseignements-personnels">Lire la politique de confidentialité</a>',
                        acceptAllBtn: 'Accepter tout',
                        showPreferencesBtn: 'Configurer',
                    },
                    preferencesModal: {
                        title: 'Personnaliser vos préférences en matière de consentement',
                        acceptAllBtn: 'Accepter tout',
                        acceptNecessaryBtn: 'Tout rejeter',
                        savePreferencesBtn: 'Sauvegarder mes préférences',
                        closeIconLabel: 'Fermer la modale',
                        sections: [
                            {
                                title: null,
                                description:
                                    'Nous utilisons des témoins (cookies) pour vous aider à naviguer efficacement et à exécuter certaines fonctionnalités. Vous trouverez des informations détaillées sur tous les cookies sous chaque catégorie de consentement ci-dessous. <br><br>Vous pouvez choisir d’activer tout ou de désactiver en partie ces témoins. Toutefois, veuillez noter que la désactivation de certains d’entre eux pourrait avoir un impact sur votre expérience de navigation.',
                            },
                            {
                                title: 'Témoins obligatoires',
                                description:
                                    'Les témoins catégorisés comme "obligatoires" sont stockés sur votre navigateur et sont essentiels pour les fonctionnalités de base du site. Cruciaux pour le bon fonctionnement du site, les témoins obligatoires ne stockent aucune donnée personnellement identifiable.',
                                linkedCategory: 'necessary',
                                cookieTable: {
                                    headers: {
                                        name: 'Nom',
                                        description: 'Description',
                                        domain: 'Domaine',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: 'token',
                                            description: 'Cookie utilisé pour la sécurité des formulaires',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 3 jours',
                                        },
                                        {
                                            name: 'user',
                                            description: 'Cookie pour gérer la connexion à la section Membre RTC',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 3 jours',
                                        },
                                        {
                                            name: 'takeover_dismissed',
                                            description: "Cookie pour gérer la modale d'alerte",
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 10 minutes',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Statistiques / Analytics / Marketing',
                                description:
                                    'Nous utilisons des témoins tiers pour analyser votre utilisation du site. Les témoins d’analytique fournissent des informations sur les interactions des visiteurs, notamment le nombre, le taux de rebond, la source de trafic, etc. Ces témoins ne seront stockés dans votre navigateur qu’avec votre consentement préalable.',
                                linkedCategory: 'analytics',
                                cookieTable: {
                                    headers: {
                                        name: 'Nom',
                                        description: 'Description',
                                        domain: 'Domaine',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: 'RT',
                                            description:
                                                'Akamai Boomerang utilise ce cookie qui évalue l’expérience du visiteur en fonction des temps de chargement de la page.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 7 jours',
                                        },
                                        {
                                            name: '_gcl_au',
                                            description:
                                                'Google Tag Manager utilise ce cookie pour expérimenter l’efficacité publicitaire des sites Web utilisant leurs services.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 3 mois',
                                        },
                                        {
                                            name: '_ga_*',
                                            description:
                                                'Google Analytics utilise ce cookie pour stocker et compter les pages vues.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 an, 1 mois et 4 jours',
                                        },
                                        {
                                            name: '_ga',
                                            description:
                                                'Google Analytics utilise ce cookie pour calculer les données de visiteurs, de session et de campagne et suivre l’utilisation du site pour le rapport d’analyse du site. Le cookie stocke des informations de manière anonyme et attribue un numéro généré de manière aléatoire pour reconnaître les visiteurs uniques.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 an, 1 mois et 4 jours',
                                        },
                                        {
                                            name: '_gid',
                                            description:
                                                'Google Analytics utilise ce cookie pour stocker des informations sur la manière dont les visiteurs utilisent un site Web tout en créant également un rapport d’analyse de la performance du site Web. Certaines des données collectées comprennent le nombre de visiteurs, leur source et les pages qu’ils visitent de manière anonyme.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 jour',
                                        },
                                        {
                                            name: '_gat_UA-*',
                                            description:
                                                'Google Analytics utilise ce cookie pour le suivi du comportement des utilisateurs.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 minute',
                                        },
                                        {
                                            name: '_fbp',
                                            description:
                                                'Facebook utilise ce cookie pour afficher des publicités soit sur Facebook, soit sur une plateforme numérique alimentée par la publicité Facebook après avoir visité le site Web.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 3 mois',
                                        },
                                        {
                                            name: 'cebs',
                                            description:
                                                'Crazyegg utilise ce cookie pour tracer la session utilisateur actuelle en interne.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: '_ce.gtld',
                                            description:
                                                'Crazyegg utilise ce cookie pour identifier le domaine de premier niveau.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: 'CONSENT',
                                            description:
                                                'YouTube utilise ce cookie via des vidéos YouTube intégrées et enregistre des données statistiques anonymes.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 2 ans',
                                        },
                                        {
                                            name: '_ce.irv',
                                            description:
                                                'CrazyEgg utilise ce cookie pour stocker la valeur isReturning pendant la session',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: '_ce.s',
                                            description:
                                                'CrazyEgg utilise ce cookie pour suivre un identifiant de session visiteur unique, suivre l’hôte et l’heure de début',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 an',
                                        },
                                        {
                                            name: '_ce.clock_event',
                                            description:
                                                'CrazyEgg utilise ce cookie pour éviter les demandes répétées à l’API Clock.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 jour',
                                        },
                                        {
                                            name: '_ce.clock_data',
                                            description:
                                                'CrazyEgg utilise ce cookie pour stocker la différence de temps entre l’heure du serveur et l’heure actuelle du navigateur.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 jour',
                                        },
                                        {
                                            name: 'cebsp_',
                                            description:
                                                'CrazyEgg utilise ce cookie pour suivre la session utilisateur actuelle en interne.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: 'test_cookie',
                                            description:
                                                'doubleclick.net utilise ce cookie pour déterminer si le navigateur de l’utilisateur supporte les cookies.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 15 minutes',
                                        },
                                        {
                                            name: 'A3',
                                            description: 'Yahoo utilise ce cookie pour de la publicité ciblée.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 an',
                                        },
                                        {
                                            name: 'fr',
                                            description:
                                                'Facebooke utilise ce cookie pour de la publicité ciblée en traçant le comportement de l’utilisateur à travers le web sur des sites comportant un Pixel Facebool ou une extension Facebook.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 an',
                                        },
                                        {
                                            name: 'YSC',
                                            description:
                                                'Youtube utilise ce cookie pour tracer les vues des vidéos intégrées dans les pages Youtube.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: 'VISITOR_INFO1_LIVE',
                                            description:
                                                'YouTube utilise ce cookie pour mesurer la bande passante, déterminant ainsi si l’utilisateur obtient l’interface du nouveau ou de l’ancien lecteur',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 6 mois',
                                        },
                                        {
                                            name: 'IDE',
                                            description:
                                                'Les cookies Google DoubleClick IDE stockent des informations sur la manière dont l’utilisateur utilise le site Web afin de lui présenter des publicités pertinentes en fonction de son profil utilisateur.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 1 an et 24 jours',
                                        },
                                        {
                                            name: 'yt-remote-device-id',
                                            description:
                                                'YouTube utilise ce cookie pour stocker les préférences vidéo de l’utilisateur lorsqu’il utilise des vidéos YouTube intégrées.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: 'yt.innertube::requests',
                                            description:
                                                'YouTube utilise ce cookie pour enregistrer un identifiant unique afin de stocker des données sur les vidéos de YouTube que l’utilisateur a visionnées.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: 'yt.innertube::nextId',
                                            description:
                                                'YouTube utilise ce cookie pour enregistrer un identifiant unique afin de stocker des données sur quelles vidéos de YouTube l’utilisateur a visionnées.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: 'yt-remote-connected-devices',
                                            description:
                                                'YouTube utilise ce cookie pour enregistrer les préférences vidéo de l’utilisateur lorsqu’il consulte des vidéos YouTube intégrées.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire à la fermeture du navigateur',
                                        },
                                        {
                                            name: 'NID',
                                            description:
                                                'Google uitlise ce cookie à des fins publicitaires; pour limiter le nombre de fois où l’utilisateur voit une publicité, éviter les publicités silencieuses indésirables et mesurer l’efficacité des publicités.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 6 mois',
                                        },
                                        {
                                            name: '%40%40',
                                            description: 'La description n’est actuellement pas disponible.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 3 jours',
                                        },
                                        {
                                            name: 'VISITOR_PRIVACY_METADATA',
                                            description: 'Cookie utilisé par Youtube',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expire après 6 mois',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Pour en savoir plus',
                                description:
                                    'Pour plus d’information, consultez notre <a class="cc-link" href="/politique-sur-la-confidentialite-et-la-protection-des-renseignements-personnels">Politique de confidentialité</a>.',
                            },
                        ],
                    },
                },
                en: {
                    consentModal: {
                        title: 'Consentement aux témoins de navigation (cookies)',
                        description:
                            'Our website uses cookies to keep the website running smoothly, to provide access to consultation statistics and to send targeted messages to our users on other web platforms. By clicking “Accept all,” you are consenting to our use of cookies.<br><a href="/politique-sur-la-confidentialite-et-la-protection-des-renseignements-personnels">Read the privacy policy</a>',
                        acceptAllBtn: 'Accept all',
                        showPreferencesBtn: 'Configure',
                    },
                    preferencesModal: {
                        title: 'Cookie preferences',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        savePreferencesBtn: 'Save my preferences',
                        closeIconLabel: 'Close',
                        sections: [
                            {
                                title: null,
                                description:
                                    'We use cookies to help you browse efficiently and use certain functions. Detailed information on all cookies can be found under each consent category below. <br><br>You can choose to enable all or partially disable these cookies. However, please note that disabling some of them may affect your browsing experience.',
                            },
                            {
                                title: 'Necessary cookies',
                                description:
                                    'Cookies categorized as “necessary” are stored on your browser and are essential for basic site functionality. Necessary cookies are crucial to the proper functioning of the site and do not store any personally identifiable data.',
                                linkedCategory: 'necessary',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: 'token',
                                            description: 'Cookie used for the security of forms',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 3 days',
                                        },
                                        {
                                            name: 'user',
                                            description: 'Cookie to manage login to the RTC Member section',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 3 days',
                                        },
                                        {
                                            name: 'takeover_dismissed',
                                            description: 'Cookie to manage the alert modal',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 10 minutes',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Statistics / Analytics / Marketing',
                                description:
                                    'We use third-party cookies to analyze your use of the site. Analytics cookies provide information about visitor interactions, including number, bounce rate, traffic source, etc. These cookies will only be stored in your browser with your prior consent.',
                                linkedCategory: 'analytics',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: 'RT',
                                            description:
                                                'Akamai Boomerang uses this cookie to evaluates visitor experience based on page load times.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 7 days',
                                        },
                                        {
                                            name: '_gcl_au',
                                            description:
                                                'Google Tag Manager uses this cookie to test the advertising effectiveness of websites using their services.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 3 months',
                                        },
                                        {
                                            name: '_ga_*',
                                            description:
                                                'Google Analytics uses this cookie to store and count page views.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 year, 1 month and 4 days',
                                        },
                                        {
                                            name: '_ga',
                                            description:
                                                'Google Analytics uses this cookie to calculate visitor, session and campaign data and track site usage for the site analytics report. The cookie stores information anonymously and assigns a randomly generated number to recognise unique visitors.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 year, 1 month and 4 days',
                                        },
                                        {
                                            name: '_gid',
                                            description:
                                                'Google Analytics uses this cookie to store information about how visitors use a website while also creating a report to analyze website performance. Some of the data collected includes the number of visitors, their source, and the pages they visit anonymously.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 day',
                                        },
                                        {
                                            name: '_gat_UA-*',
                                            description: 'Google Analytics uses this cookie to track user behaviour.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 minute',
                                        },
                                        {
                                            name: '_fbp',
                                            description:
                                                'Facebook uses this cookie to display ads either on Facebook or on a digital platform powered by Facebook advertising after visiting the website.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 3 months',
                                        },
                                        {
                                            name: 'cebs',
                                            description:
                                                'Crazy Egg uses this cookie to track the current user session internally.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: '_ce.gtld',
                                            description: 'Crazy Egg uses this cookie to identify the top-level domain.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: 'CONSENT',
                                            description:
                                                'YouTube uses this cookie via embedded YouTube videos and records anonymous statistical data.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 2 years',
                                        },
                                        {
                                            name: '_ce.irv',
                                            description:
                                                'Crazy Egg uses this cookie to store the isReturning value during the session.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: '_ce.s',
                                            description:
                                                'Crazy Egg uses this cookie to track a unique visitor session ID, host, and start time.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 year',
                                        },
                                        {
                                            name: '_ce.clock_event',
                                            description:
                                                'Crazy Egg uses this cookie to avoid repeat requests to the Clock API.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 day',
                                        },
                                        {
                                            name: '_ce.clock_data',
                                            description:
                                                'Crazy Egg uses this cookie to store the time difference between the server time and the current browser time',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 day',
                                        },
                                        {
                                            name: 'cebsp_',
                                            description:
                                                'Crazy Egg uses this cookie to track the current user session internally.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: 'test_cookie',
                                            description:
                                                'doubleclick.net uses this cookie to determine whether the user’s browser supports cookies.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 15 minutes',
                                        },
                                        {
                                            name: 'A3',
                                            description: 'Yahoo uses this cookie for targeted advertising.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 year',
                                        },
                                        {
                                            name: 'fr',
                                            description:
                                                'Facebook uses this cookie for targeted advertising by tracking user behaviour across the web on sites with a Facebook pixel or a Facebook extension.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 year',
                                        },
                                        {
                                            name: 'YSC',
                                            description:
                                                'YouTube uses this cookie to track views of videos embedded in YouTube pages.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: 'VISITOR_INFO1_LIVE',
                                            description:
                                                'YouTube uses this cookie to measure bandwidth, determining whether the user is getting the interface from the new or old player.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 6 months',
                                        },
                                        {
                                            name: 'IDE',
                                            description:
                                                'Google DoubleClick IDE cookies store information about how the user uses the website in order to show relevant ads based on the user’s profile.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 1 year and 24 days',
                                        },
                                        {
                                            name: 'yt-remote-device-id',
                                            description:
                                                'YouTube uses this cookie to store the user’s video preferences when using embedded YouTube videos.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: 'yt.innertube::requests',
                                            description:
                                                'YouTube uses this cookie to record a unique identifier to store data about the YouTube videos the user has viewed.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: 'yt.innertube::nextId',
                                            description:
                                                'YouTube uses this cookie to record a unique identifier in order to store data on which YouTube videos the user has viewed.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: 'yt-remote-connected-devices',
                                            description:
                                                'YouTube uses this cookie to save the user’s video preferences when viewing embedded YouTube videos.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires when the browser is closed',
                                        },
                                        {
                                            name: 'NID',
                                            description:
                                                'Google uses this cookie for advertising purposes to limit the number of times the user sees an ad, avoid unwanted silent ads, and measure ad effectiveness.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 6 months',
                                        },
                                        {
                                            name: '%40%40',
                                            description: 'The description is currently unavailable.',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 3 days',
                                        },
                                        {
                                            name: 'VISITOR_PRIVACY_METADATA',
                                            description: 'Cookie used by Youtube',
                                            domain: 'rtcquebec.ca',
                                            expiration: 'Expires after 6 months',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Find out more',
                                description:
                                    'For more information, see our <a class="cc-link" href="/politique-sur-la-confidentialite-et-la-protection-des-renseignements-personnels">Privacy Policy</a>.',
                            },
                        ],
                    },
                },
            },
        },
    });
    // Bouton pour changer les préférences de cookies
    const cookieConsentTrigger = document.querySelector('.cookie-consent-trigger');
    if (cookieConsentTrigger) {
        cookieConsentTrigger.addEventListener('click', () => {
            CookieConsent.showPreferences();
        });
    }
    // Événement pour indiquer la vue de la bannière de consentement aux cookies
    if (CookieConsent.getCookie('cc_cookie') === undefined) {
        gtag('event', 'cookie_banner', {
            event_category: 'Cookie Consent',
            event_label: 'La bannière de cookie s’est affichée',
        });
    }
});
